import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import "../../../styles/Auth/stock.css";
import { Box } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import { getData } from '../../../webService/webservice.js'
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import "../../../styles/Auth/stock.css";
import StockViewPopup from "./viewStockPopUp.jsx";
const StocksPage = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    const [stocks, setStocks] = useState([]);
    const sessionToken = sessionStorage.getItem("sessionToken");
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(5);
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        "SL",
        "SupplierName",
        "Product Name",
        "Product Type",
        "Purchase Quantity",
        "Purchase Price (₹)",
        "Selling Price (₹)",
        "Total Amount (₹)",
        "Current Stock",
        "Action"
    ];


    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [StockPopupOpen, setIsStockPopupOpen] = useState(false);
    const [selectedStocks, setSelectedStocks] = useState(null);

    const [filters, setFilters] = useState({
        startDate: "",
        endDate: ""
    });

    const fetchStocks = async (page, limit, searchQuery, filters = {}) => {
        const params = {
            page,
            limit,
            supplierName: searchQuery?.trim() || "",
            type: "Purchase"
        };
        if (filters.startDate) params.startDate = filters.startDate;
        if (filters.endDate) params.endDate = filters.endDate;

        try {
            setLoading(true);
            const response = await getData('stocks/stocks', params, sessionToken);
            const resultsWrapper = response?.data?.[0];
            const stocksList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setStocks(stocksList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Stocks");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStocks(currentPage, limit, searchQuery, filters);
    }, [currentPage, limit, refreshKey, searchQuery, filters]);

    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };
    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const handleViewStock = async (stockId) => {
        try {
            setLoading(true);
            const sessionToken = sessionStorage.getItem("sessionToken");

            const response = await getData(
                `stocks/stock/${stockId}`,
                sessionToken
            );

            // ✅ Pass the full response (no .data here)
            setSelectedStocks(response);
            setIsStockPopupOpen(true);
        } catch (error) {
            console.error("Error fetching Stock Details:", error);
            toast.error(error.message || "Failed to fetch Stock Details");
        } finally {
            setLoading(false);
        }
    };

    const handleExportStock = async () => {
        try {
            if (!stocks || stocks.length === 0) {
                alert("No stock data available to export");
                return;
            }

            // Optional — apply filters on frontend before export
            let filteredData = stocks;

            if (filters?.startDate && filters?.endDate) {
                const start = new Date(filters.startDate);
                const end = new Date(filters.endDate);
                filteredData = filteredData.filter(stock => {
                    const date = new Date(stock.createdAt);
                    return date >= start && date <= end;
                });
            }

            if (filters?.supplierName) {
                filteredData = filteredData.filter(stock =>
                    stock?.supplierDetails?.[0]?.supplierName
                        ?.toLowerCase()
                        ?.includes(filters.supplierName.toLowerCase())
                );
            }

            // Format data for Excel
            const exportData = filteredData.map((stock, index) => ({
                "S.No": index + 1,
                "Supplier Name": stock?.supplierDetails?.[0]?.supplierName || "-",
                "Product Name": stock?.productDetails?.title || "-",
                "Purchase Invoice No": stock?.purchaseDetails?.[0]?.purchaseInvoiceNumber || "-",
                "Purchase Invoice Date": stock?.purchaseDetails?.[0]?.purchaseInvoiceDate
                    ? new Date(stock.purchaseDetails[0].purchaseInvoiceDate).toLocaleDateString()
                    : "-",
                "Quantity": stock?.quantity || 0,
                "Purchase Price": stock?.paginatedResults?.[0]?.products?.[0]?.purchasePrice || 0,
                "Selling Price": stock?.purchaseDetails?.[0]?.products?.[0]?.sellingPrice || 0,
                "Total Amount": stock?.purchaseDetails?.[0]?.purchaseInvoiceAmount || 0,
                "Stock Status": stock?.stockStatus || "-",
                "Created Date": new Date(stock.createdAt).toLocaleDateString(),
            }));

            // Convert JSON to worksheet
            const worksheet = XLSX.utils.json_to_sheet(exportData);

            // Create workbook
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");

            // Convert workbook to Excel file
            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            // Save the Excel file
            const fileName = `Stock_Report_${new Date().toISOString().slice(0, 10)}.xlsx`;
            const data = new Blob([excelBuffer], { type: "application/octet-stream" });
            saveAs(data, fileName);

        } catch (error) {
            console.error("Error exporting stock data:", error);
            alert("Failed to export stock data");
        }
    };

    return (
        <div className="Stocks-layout">
            <div className="Stocks-content">
                <main className="Stocks-main">
                    <>
                        <div className="Stocks-widgets">
                            <div className="Stocks-widgets-header">
                                <h3>Stocks</h3>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    className="Stocks-search-input"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                <div className="Stock-filterDate">
                                    <div className="Start-Date"
                                        style={{
                                            display: " flex",
                                            padding: "10px",
                                            gap: "10px",
                                            alignItems: "center",
                                        }}
                                    >
                                        <label>Start Date</label>
                                        <input
                                            type="date"
                                            id="startDate"
                                            className="stock-date-input"
                                            value={filters.startDate || ""}
                                            onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
                                            style={{
                                                background: "#e6cf80",
                                                border: "none",
                                                padding: "10px",
                                                borderRadius: "10px"
                                            }}
                                        />
                                    </div>
                                    <div className="End-Date">
                                        <label>End Date</label>
                                        <input
                                            type="date"
                                            id="endDate"
                                            className="stock-date-input"
                                            value={filters.endDate || ""}
                                            onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
                                            style={{
                                                background: "#e6cf80",
                                                border: "none",
                                                padding: "10px",
                                                borderRadius: "10px"
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="Clear-button">
                                    <button type="clear-stock"
                                        style={{
                                            background: "#8d2629",
                                            color: "white",
                                            fontWeight: "600px",
                                            padding: "10px",
                                            border: "1px solid #e6cf80",
                                            borderRadius: "10px"
                                        }}
                                        onClick={() => setFilters("")}
                                    >
                                        Clear
                                    </button>
                                </div>
                                <div className="Export-button">
                                    <button type="export-stock"
                                        style={{
                                            background: "#8d2629",
                                            color: "white",
                                            fontWeight: "600px",
                                            padding: "10px",
                                            border: "1px solid #e6cf80",
                                            borderRadius: "10px"
                                        }}
                                        onClick={handleExportStock}
                                    >
                                        Export
                                    </button>
                                </div>
                            </div>

                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-product-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-product-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#E6CF80',
                                                        zIndex: 1,

                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {stocks.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={11}>
                                                    <Typography
                                                        sx={{
                                                            textAlign: "center",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            padding: "20px",
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        No Stocks found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            stocks.map((item, index) => {
                                                console.log(item);
                                                const purchaseInfo = item.purchaseDetails?.[0] || {};
                                                const productInfo = item.productDetails || {};
                                                const purchaseProductInfo = item || {};
                                                const purchaseProduct = purchaseInfo?.products?.[0] || {};
                                                // const productAttrs = productInfo?.attributes || [];
                                                // const purchaseAttrs = purchaseProduct?.attributes?.[0]?.values || [];
                                                // Combine attributes from both product & purchase details
                                                // const combinedAttributes = productAttrs.map((att) => {
                                                //     const matchingPurchaseAttr = purchaseAttrs.find(
                                                //         (v) =>
                                                //             v.attributeId?.toString() ===
                                                //             att.attributeId?._id?.toString()
                                                //     );

                                                //     const valuesWithQty =
                                                //         matchingPurchaseAttr?.values?.length > 0
                                                //             ? matchingPurchaseAttr.values
                                                //                 .map(
                                                //                     (val) =>
                                                //                         `${val.name || val.value || "—"} (${val.quantity ?? 0
                                                //                         })`
                                                //                 )
                                                //                 .join(", ")
                                                //             : matchingPurchaseAttr?.name
                                                //                 ? `${matchingPurchaseAttr.name} (${matchingPurchaseAttr.quantity ?? 0})`
                                                //                 : "—";

                                                //     return {
                                                //         name:
                                                //             att.attributeName ||
                                                //             att.name ||
                                                //             att.attributeId?.attributeName ||
                                                //             "Attribute",
                                                //         value: valuesWithQty,
                                                //     };
                                                // });

                                                return (
                                                    <TableRow key={item._id}>
                                                        {/* SL */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {item?.supplierDetails?.[0]?.supplierName || "—"}
                                                            </Typography>
                                                        </TableCell>
                                                        {/* Product Name */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {productInfo?.title || "—"}
                                                            </Typography>
                                                        </TableCell>

                                                        {/* Product Type */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {productInfo?.productType || "—"}
                                                            </Typography>
                                                        </TableCell>

                                                        {/* Attributes */}
                                                        {/* Attributes */}
                                                        {/* <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {(() => {
                                                                    const productAttr = productInfo?.attributes?.[0];
                                                                    const attributeName = productAttr?.attributeName || "Attribute";
                                                                    const purchaseAttrValues =
                                                                        purchaseInfo?.products?.[0]?.attributes?.[0]?.values || [];

                                                                    if (purchaseAttrValues.length === 0) return "—";

                                                                    return `${attributeName}: ` +
                                                                        purchaseAttrValues
                                                                            .map(v => `${v.name} (${v.quantity})`)
                                                                            .join(", ");
                                                                })()}
                                                            </Typography>
                                                        </TableCell>*/}


                                                        {/* Purchase Quantity */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {purchaseProductInfo?.quantity || 0}
                                                            </Typography>
                                                        </TableCell>

                                                        {/* Purchase Price (₹) */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                ₹{purchaseProductInfo?.purchasePrice?.toLocaleString() || 0}
                                                            </Typography>
                                                        </TableCell>


                                                        {/* Selling Price (₹) */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                ₹{purchaseProductInfo?.sellingPrice?.toLocaleString() || 0}
                                                            </Typography>
                                                        </TableCell>


                                                        {/* Total Amount (₹) */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                ₹{purchaseInfo?.purchaseInvoiceAmount?.toLocaleString() || 0}
                                                            </Typography>
                                                        </TableCell>

                                                        {/* Current Stock */}
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {productInfo?.quantityInStock || 0}
                                                            </Typography>
                                                        </TableCell>

                                                        {/* Action */}
                                                        <TableCell>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    gap: 2,
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}
                                                            >
                                                                <Icon icon={plusIcon} width={20} height={20} onClick={() => handleViewStock(item._id)} />
                                                                <StockViewPopup
                                                                    isOpen={StockPopupOpen}
                                                                    onClose={() => setIsStockPopupOpen(false)}
                                                                    stockData={selectedStocks}
                                                                />
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="Stocks-bottom">
                                <div className="Stocks-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="Stocks-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="Stocks-section spacer"></div>
                                <div className="Stocks-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                        </div>
                    </>
                </main>
            </div>
        </div >
    );
};

export default StocksPage;